import { SUPPORTED_UNITS_SCHEMA } from '../quote-unit/unit-types';
import { CurrencyCodeSchema } from '@schuettflix/utils';
import { PRODUCT_TYPE_SCHEMA } from '../product-type/product-types';
import { z } from 'zod';
import { PRODUCT_CATEGORY_SCHEMA } from '../order-product/product-category';
import { FREIGHT_TYPE_SCHEMA } from '../product-channel/freight-type';

export const DealProductSchema = z.strictObject({
    productType: PRODUCT_TYPE_SCHEMA.nullable(),
    productCategory: PRODUCT_CATEGORY_SCHEMA.nullable(),
    freightType: FREIGHT_TYPE_SCHEMA.nullable(),
    name: z.string(),
    productTypeConfig: z.strictObject({
        mappingStrategy: z.enum(['MANUAL', 'AUTO']),
        options: z.array(PRODUCT_TYPE_SCHEMA).nullable(),
    }),
});

export type DealProduct = z.input<typeof DealProductSchema>;

export const DealLineItemSchema = z.strictObject({
    product: DealProductSchema,
    quota: z.number(),
    unit: SUPPORTED_UNITS_SCHEMA,
    remark: z.string().nullable(),
    salesPrice: z.number(),
    materialPrice: z.number().nullable(),
    transportPrice: z.number().nullable(),
    francoPrice: z.number().nullable(),
    currencyCode: CurrencyCodeSchema.nullable(),
    salesforceMetaData: z.strictObject({
        opportunityId: z.string(),
        opportunityLineItemId: z.string(),
        supplierAccountId: z.string().nullable(),
        carrierAccountId: z.string().nullable(),
    }),
});

export type DealLineItem = z.input<typeof DealLineItemSchema>;

export const DealSchema = z.strictObject({
    name: z.string(),
    lineItems: z.array(DealLineItemSchema),
    salesforceMetadata: z.strictObject({
        opportunityId: z.string(),
        customerAccountId: z.string(),
    }),
});

export type Deal = z.input<typeof DealSchema>;

export const GetDealResponseSchema = z
    .object({
        deal: DealSchema,
        organizations: z.array(
            z.object({
                salesforceAccountId: z.string(),
                organization: z
                    .object({
                        id: z.number(),
                        name: z.string(),
                    })
                    .nullable(),
            })
        ),
    })
    .nullable();

export type GetDealResponse = z.input<typeof GetDealResponseSchema>;
